// Backend
import axios from 'axios';

// Components
import { DluchApi } from '../constants/SharedComponents';

// Functionality
import secureLocalStorage from 'react-secure-storage';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

const RefreshToken = function (msalInstance, navigate) {

  const refreshToken = async function () {
    const currentUser = parsedUserData();

    if (currentUser.isUsingSSO === false) {
      return await getNewToken();
    }
    else {
      await msalInstance.initialize();

      const account = msalInstance.getAllAccounts()[0];

      if (account) {
        try {
          await msalInstance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: account
          });

          return await getNewToken();
        }
        catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            msalInstance.loginRedirect({
              scopes: ["User.Read"]
            });
          }

          throw error;
        }
      }
    }
  };

  const getNewToken = async function () {
    const currentUser = parsedUserData();
    const Api = new DluchApi('SessionsRefresh');
    const token = currentUser.refreshToken;
    const requestPayload = { refreshToken: token };

    try {
      const response = await axios.post(Api.ApiRequestUrl(), requestPayload, { timeout: 30000 });
      const responseData = response.data.content;

      secureLocalStorage.removeItem('userDetails');
      secureLocalStorage.setItem('userDetails', JSON.stringify(responseData));

      return responseData.token;
    }
    catch (error) {
      secureLocalStorage.removeItem('userDetails');
      navigate('/sessions/new');
      throw error;
    }
  };

  const parsedUserData = function () {
    const raw = secureLocalStorage.getItem('userDetails');
    if (raw) {
      try {
        return JSON.parse(raw);
      } catch (e) {
        console.error('Failed to parse userDetails from local storage', e);
      }
    }
    return {};
  };

  this.tokenValid = function () {
    let validToken = false;

    if (parsedUserData()) {
      validToken = true;
    }

    return validToken;
  };

  this.tokenRefresh = async function () {
    return await refreshToken();
  };
};

export default RefreshToken;
